import React from "react";
import FormNameProfile from "../FormNameProfile/FormNameProfile";
import { TitleSection, BreakLine } from "./UserSection";

import "./UserUpdateProfile.scss";

const UserUpdateProfile = () => (
  <div id="user-update-profile">
    <TitleSection title="Actualizar los datos de mi cuenta" />
    <BreakLine />

    <div className="form">
      <FormNameProfile isUpdate />
    </div>
  </div>
);

export default UserUpdateProfile;
